import { render, staticRenderFns } from "./ViewObjectRefWidget.vue?vue&type=template&id=223521aa"
import script from "./ViewObjectRefWidget.vue?vue&type=script&lang=js"
export * from "./ViewObjectRefWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports